import { Pipe, PipeTransform } from '@angular/core';

/**
 * Todo, rename, is poorly named, truncates string
 */
@Pipe({ name: 'wrap' })
export class WrapTextPipe implements PipeTransform {
  transform(value: string, length: number): string {
    if (value && length && length > 0) {
      let str = value.trim();
      if (str.length > length) {
        return `${str.slice(0, length)}...`;
      }
    }
    return value;
  }
}
